import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col, Button } from 'react-bootstrap';
import { find as _find } from 'lodash';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';

import SocialMediaLoginSecret from 'components/modals/SocialMediaLoginSecret';

class PaymentConfigPaypal extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showEnterSocialMediaSecret: false,
    };
  }

  showEnterSocialMediaSecret = () => {
    this.setState({ showEnterSocialMediaSecret: true, socialMediaLoginSecretType: 'paypalSecret' });
  };

  closeEnterSocialMediaSecret = () => {
    this.setState({ showEnterSocialMediaSecret: false });
  };

  getSocialMediaLoginIcon = type => {
    const { socialMediaLoginSecrets } = this.props;

    if (socialMediaLoginSecrets.pending) {
      return <i className="fa fa-circle-notch fa-spin fa-fw" />;
    }

    // check if the secret was already saved
    const socialMediaLoginSecret = _find(socialMediaLoginSecrets.data.list, ['type', type]);
    if (socialMediaLoginSecret && socialMediaLoginSecret.secret) {
      return <i className="fas fa-check text-success hint-text fa-fw" />;
    }

    // default: we are still missing the app secret
    return <i className="fas fa-times text-warning hint-text fa-fw" />;
  };

  render() {
    const {
      intl: { messages },
      entity,
      disabled,
      inModal,
      socialMediaLoginSecrets,
    } = this.props;

    return (
      <Row>
        <Col xs={12} md={inModal ? 12 : 4}>
          <div className="panel panel-transparent">
            <div className="panel-body">
              <p className="form-group-title">
                <i className="fab fa-paypal" /> PayPal Payment Config
              </p>
              <div className="form-group-attached">
                <FormInput
                  label="PayPal Client ID"
                  name="paypalClientId"
                  value={entity.getPaypalClientId()}
                  meta={entity.getPaypalClientIdMetaInformation()}
                  validation={entity.getPaypalClientIdValidationResult()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                />
                <div className="form-group form-group-default">
                  <label>PayPal Secret Key</label>
                  <div style={{ position: 'relative', width: '100%' }}>
                    {this.getSocialMediaLoginIcon('paypalSecret')}
                    <Button
                      className="m-l-5"
                      bsSize="xsmall"
                      onClick={this.showEnterSocialMediaSecret}
                      disabled={disabled}
                    >
                      {messages.enter_app_secret}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>

        <SocialMediaLoginSecret
          show={this.state.showEnterSocialMediaSecret}
          close={this.closeEnterSocialMediaSecret}
          socialMediaLoginSecrets={socialMediaLoginSecrets.data.list}
          type={this.state.socialMediaLoginSecretType}
          whiteLabelId={entity.getId()}
        />
      </Row>
    );
  }
}
PaymentConfigPaypal.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    socialMediaLoginSecrets: state.list.socialMediaLoginSecrets,
  };
};

export default injectIntl(connect(mapStateToProps)(PaymentConfigPaypal));
